export default [{
        path: 'home',
        label: 'Home',
    },
    {
        path: 'about',
        label: 'About',
    },
    {
        path: 'services',
        label: 'Services',
    },
    {
        path: 'portfolio',
        label: 'Portfolio',
    },
    {
        path: 'contact',
        label: 'Contact',
    },
];